<template>
  <div id="__nuxt" style="height: auto !important">
    <div class="pc record___en" data-v-79cdd511="" style="height: auto !important">
      <HeadTop></HeadTop>
      <div class="n-config-provider" style="height: auto !important">
        <div class="page-a">
          <div data-v-a1201187="" class="record-a pc_container">
            <!-- 用户信息卡片 -->
            <div class="user-card">
              <div class="user-header">
                <img src="../../static/xm.png" alt="avatar" class="user-avatar" />
                <div class="user-info">
                  <p class="user-name">{{ info.email }}</p>
                  <p class="user-id">ID: {{ info.uid }}</p>
                </div>
                <button class="btn-logout">{{ $t('_m._tcdl') }}</button>
              </div>

              <!-- 钱包余额 -->
              <div class="balance-grid">
                <!-- 左列 -->
                <div class="balance-group">
                  <div class="balance-item">
                    <span class="balance-number">${{ wallet.balance || 0 }}</span>
                    <div class="balance-label">
                      <span class="iconfont icon-meiyuan" style="color: #ff9800; font-size: 19px"></span>
                      <span>{{ $t('_h._ye') }}</span>
                    </div>
                  </div>
                  <div class="balance-item">
                    <span class="balance-number">${{ wallet.freeze || 0 }}</span>
                    <div class="balance-label">
                      <span class="iconfont icon-33" style="color: #03A9F4; font-size: 19px"></span>
                      <span>{{ $t('_h._dj') }}</span>
                    </div>
                  </div>
                  <div class="action-buttons">
                    <button class="btn-action primary" @click="onDeposit">{{ $t('_m._cb') }}</button>
                    <button v-if="info.is_bank == 2" class="btn-action bank" @click="onBank">{{ $t('_m._yhzz') }}</button>
                    <button class="btn-action withdraw" @click="onWithdrawal">{{ $t('_m._tb') }}</button>
                  </div>
                </div>

                <!-- 右列 -->
                <div class="balance-group right">
                  <div class="balance-item video-balance">
                    <span class="balance-number">${{ wallet.video || 0 }}</span>
                    <div class="balance-label">
                      <span class="label-icon"></span>
                      <span>{{ $t('_sp._dbye') }}</span>
                    </div>
                  </div>
                  <button class="btn-action transfer" @click="onTransfer">{{ $t('_sp.hzye') }}</button>
                </div>
              </div>
            </div>

            <!-- 子路由 -->
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadTop from '@/components/base/head.vue'

export default {
  name: 'RecordVue',
  components: {
    HeadTop
  },
  data() {
    return {
      wallet: {},
      info: {
        is_bank: 1
      }
    }
  },
  created() {
    this.getInfo()
    this.getWallet()
  },
  methods: {
    getInfo() {
      this.info = this.$common.getInfo() || { is_bank: 1 }
    },

    getWallet() {
      const hide = this.$message.loading({ content: 'loading...', key: 'msg' })
      this.$api.userWallet
        .getWallet()
        .then((res) => {
          hide()
          if (res.data) {
            this.wallet = res.data
          } else {
            this.$message.error('获取钱包信息失败')
          }
        })
        .catch(() => {
          hide()
          this.$message.error('获取钱包信息失败')
        })
    },

    onDeposit() {
      this.$router.push({ name: 'deposit' })
    },

    onTransfer() {
      this.$router.push({ name: 'transfer' })
    },

    onBank() {
      this.$router.push({ name: 'bank' })
    },

    onWithdrawal() {
      this.$router.push({ name: 'withdraw' })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   钱包页面 - 暗色主题
   ============================================================ */

.pc.record___en {
  background: #0b0d0f;
  min-height: 100vh;
}

.page-a {
  background: #131313;
}

.pc_container {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px 24px 40px;
}

/* ============================================================
   用户卡片
   ============================================================ */
.user-card {
  background: #0f1419;
  border-radius: 16px;
  border: 1px solid #1a1f26;
  padding: 24px 28px;
  margin-bottom: 24px;
}

/* 用户头部 */
.user-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 20px;
  border-bottom: 1px solid #1a1f26;
}

.user-avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #2a3138;
  background: #fff;
}

.user-info {
  flex: 1;
}

.user-name {
  color: #e8edf2;
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.user-id {
  color: #5a6672;
  font-size: 14px;
  margin: 2px 0 0;
}

.btn-logout {
  padding: 6px 20px;
  border-radius: 20px;
  border: 1px solid #2a3138;
  background: transparent;
  color: #8a949f;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.25s;
}

.btn-logout:hover {
  background: rgba(229, 9, 20, 0.12);
  border-color: #e50914;
  color: #e50914;
}

/* ============================================================
   余额网格
   ============================================================ */
.balance-grid {
  display: flex;
  gap: 40px;
  padding-top: 20px;
  flex-wrap: wrap;
}

.balance-group {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.balance-group.right {
  margin-left: auto;
}

/* 余额项 */
.balance-item {
  display: flex;
  flex-direction: column;
  background: #0a0d0f;
  border-radius: 12px;
  padding: 12px 20px;
  min-width: 140px;
  border: 1px solid #1a1f26;
}

.balance-number {
  color: #e8edf2;
  font-size: 24px;
  font-weight: 700;
}

.balance-label {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #d5d5d5;
  font-size: 15px !important;
  margin-top: 2px;
}

.balance-label .label-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

/* 视频余额特殊样式 */
.video-balance {
  border-color: rgba(255, 193, 7, 0.2);
}

.video-balance .balance-number {
  color: #ffc107;
}

/* ============================================================
   操作按钮
   ============================================================ */
.action-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.btn-action {
  padding: 8px 24px;
  border: none;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-action.primary {
  background: linear-gradient(135deg, #e50914, #b20710);
  color: #fff;
}

.btn-action.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(229, 9, 20, 0.3);
}

.btn-action.bank {
  background: transparent;
  color: #e8edf2;
  border: 1px solid #2a3138;
}

.btn-action.bank:hover {
  background: #181e24;
  border-color: #3a4652;
}

.btn-action.withdraw {
  background: transparent;
  color: #fb3867;
  border: 1px solid #fb3867;
}

.btn-action.withdraw:hover {
  background: rgba(251, 56, 103, 0.1);
  transform: translateY(-2px);
}

.btn-action.transfer {
  background: #ffc107;
  color: #0b0d0f;
  font-weight: 600;
}

.btn-action.transfer:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(255, 193, 7, 0.3);
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 1024px) {
  .balance-grid {
    flex-direction: column;
    gap: 20px;
  }

  .balance-group.right {
    margin-left: 0;
  }

  .balance-group {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .pc_container {
    padding: 12px;
  }

  .user-card {
    padding: 16px 18px;
  }

  .user-header {
    flex-wrap: wrap;
  }

  .user-avatar {
    width: 44px;
    height: 44px;
  }

  .user-name {
    font-size: 16px;
  }

  .balance-group {
    gap: 12px;
  }

  .balance-item {
    min-width: 100px;
    padding: 10px 16px;
  }

  .balance-number {
    font-size: 20px;
  }

  .action-buttons {
    width: 100%;
  }

  .btn-action {
    flex: 1;
    text-align: center;
    padding: 8px 16px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .user-card {
    padding: 12px 14px;
  }

  .user-header {
    gap: 10px;
  }

  .user-avatar {
    width: 36px;
    height: 36px;
  }

  .user-name {
    font-size: 14px;
  }

  .user-id {
    font-size: 12px;
  }

  .btn-logout {
    padding: 4px 14px;
    font-size: 12px;
  }

  .balance-item {
    min-width: 80px;
    padding: 8px 12px;
  }

  .balance-number {
    font-size: 17px;
  }

  .balance-label {
    font-size: 11px;
  }

  .btn-action {
    padding: 6px 12px;
    font-size: 12px;
  }
}
</style>

<!-- ============================================================
   保留原有样式（供子组件使用）
   ============================================================ -->
<style>
.setqe {
  background: #fff !important;
  color: #fb3867 !important;
  border: 1px solid #fb3867 !important;
}

.xx2 {
  background: url('../../static/img/coins.png') center top / 100% no-repeat;
}

.xx3 {
  background: url('../../static/img/bonus.png') center top / 100% no-repeat;
}
</style>
